export default __webpack_public_path__ + "static/media/twitter.07d2b8ba.svg";